import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { ArrowRight } from 'lucide-react';
import * as Icons from 'lucide-react';
import { Tool } from '@/types/tool';

interface ToolCardProps {
  tool: Tool;
  index?: number;
}

const ToolCard = ({ tool, index = 0 }: ToolCardProps) => {
  const IconComponent = Icons[tool.icon as keyof typeof Icons] as React.ElementType;

  return (
    <Link to={tool.path}>
      <Card 
        className="group relative h-full overflow-hidden border-border/50 bg-card transition-all duration-300 hover:border-primary/30 hover:shadow-lg"
        style={{ animationDelay: `${index * 50}ms` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        <CardHeader className="relative pb-3">
          <div className="mb-3 flex items-center justify-between">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10 text-primary transition-transform duration-300 group-hover:scale-110">
              {IconComponent && <IconComponent className="h-6 w-6" />}
            </div>
            <Badge variant="secondary" className="text-xs capitalize">
              {tool.category}
            </Badge>
          </div>
          <CardTitle className="text-lg font-semibold text-card-foreground transition-colors group-hover:text-primary">
            {tool.name}
          </CardTitle>
          <CardDescription className="line-clamp-2 text-sm text-muted-foreground">
            {tool.description}
          </CardDescription>
        </CardHeader>
        <CardContent className="relative pt-0">
          <div className="flex items-center gap-2 text-sm font-medium text-primary opacity-0 transition-all duration-300 group-hover:opacity-100">
            <span>Open Tool</span>
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};

export default ToolCard;
